import { Component, DOCUMENT, OnDestroy, Renderer2, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ConfigService } from "../../shared/services/config.service";
import { CustomizerService } from "../../shared/services/customizer.service";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-content-layout",
    templateUrl: "./content-layout.component.html",
    imports: [RouterOutlet],
})
export class ContentLayoutComponent implements OnDestroy {
  private configService = inject(ConfigService);
  private document = inject(DOCUMENT);
  private renderer = inject(Renderer2);
  private customizerService = inject(CustomizerService);

  constructor() {
    this.configService.templateConf$
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.loadLayout());
  }

  loadLayout() {
    this.removeTransparentBGClasses();
    this.renderer.removeClass(this.document.body, "menu-expanded");
    this.renderer.removeClass(this.document.body, "navbar-static");
    this.renderer.removeClass(this.document.body, "menu-open");
    this.renderer.addClass(this.document.body, "blank-page");
  }

  removeTransparentBGClasses() {
    this.customizerService.transparent_colors.forEach((_) => {
      this.renderer.removeClass(this.document.body, _.class);
    });
    this.customizerService.transparent_colors_with_shade.forEach((_) => {
      this.renderer.removeClass(this.document.body, _.class);
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(this.document.body, "auth-page");
  }
}
